import * as Yup from "yup";

export const ConsumerInitializeSchema = () => {
  return Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Enter valid Email.")
      .required("Email is required"),
  });
};

export const ConsumerCTISchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .email("Enter valid Email.")
      .required("Email is required"),
  });
};
